var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useState } from "react";
import { isMissingFeatureError } from '@core/services/capabilities';
export function isAuthenticated(context) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        // Anonymous sessions (no userKey) are intentionally unauthenticated — always report as authenticated
        // so the re-login modal never fires.
        if (!context.userKey)
            return true;
        if (context.apiKey) {
            try {
                const response = yield context.executeService('Lucy', 'IsAuthenticated', {}, { json: true });
                // cehck the response 
                return (((_a = response === null || response === void 0 ? void 0 : response[0]) === null || _a === void 0 ? void 0 : _a.authenticated) == 'True');
            }
            catch (e) {
                // A server without the service can't tell us anything about the session — say authenticated
                // so the re-login modal never fires. (This used to call .toLowerCase() on the thrown value,
                // which is an Error for a transport failure, and threw a TypeError out of the catch.)
                if (isMissingFeatureError(e))
                    return true;
                // A transport failure throws an Error object, not a server string — it says nothing about
                // the session, and a real 401 already surfaces the login UI directly from the batch
                // executor. Treat it as inconclusive so a flaky network can't trip the re-login flow.
                if (typeof e !== 'string')
                    return true;
                // a server-produced string rejection we don't recognise — assume the user is not logged in
                return false;
            }
        }
        // skip checking auth status if api key is null
        console.log('skip checking auth status if api key is null ');
        return true;
    });
}
export const useIsAuthenticated = (context, interval) => {
    const [authenticated, setAuthenticated] = useState(true);
    const timerRef = useRef(null);
    const failCountRef = useRef(0);
    useEffect(() => {
        const check = () => __awaiter(void 0, void 0, void 0, function* () {
            const ok = yield isAuthenticated(context);
            if (ok) {
                failCountRef.current = 0;
                setAuthenticated(true);
            }
            else {
                failCountRef.current += 1;
                // require 2 consecutive failures before flipping — absorbs transient network/backend blips
                if (failCountRef.current >= 2)
                    setAuthenticated(false);
            }
        });
        check();
        if (timerRef.current)
            clearInterval(timerRef.current);
        if (interval) {
            timerRef.current = setInterval(check, interval);
        }
        return () => {
            if (timerRef.current)
                clearInterval(timerRef.current);
        };
    }, [context, interval]);
    return authenticated;
};
